export default "__VITE_ASSET__BosFIBg6__"